import { render, staticRenderFns } from "./MerchandisingContact.vue?vue&type=template&id=a747ee1a"
import script from "./MerchandisingContact.vue?vue&type=script&lang=js"
export * from "./MerchandisingContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports